import { AllocationHistory } from '@/components/compliance-page/allocationHistoryPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const AllocationHistoryPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Allocation History</title>
      </Head>
      <AllocationHistory />
    </>
  );
};

export default AllocationHistoryPage;
